import i18n from "@/i18n";

export const channelGroupsFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "actions",
        label: ""
    },
    {
        key: "drag",
        label: "",
        class: "draggable-btn-cell"
    }
];

export const channelGroupsChannelsFields = [
    {
        key: "name",
        label: i18n.t("common.name")
    },
    {
        key: "actions",
        label: ""
    },
    {
        key: "drag",
        label: "",
        class: "draggable-btn-cell"
    }
];
